import { OfferLegalInfoList } from './../interfaces/cart-details.interface';
import { AccessorySecondPageModel } from './accessory-second-page.model';
import { AppInjector } from '../utils/services/set-app-injector';
import { LoaderMessage } from '../utils/loaders/loader-message';
import { LoadersService } from '../utils/loaders/loaders.service';
import { LoaderActions } from '../utils/loaders/loader-actions.enum';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../external-interfaces/notification-provider.service';
import { CommonInfoService } from '../cart-process/common-info.service';
import { ProcessTypeEnum } from './cartDetails/process-type.enum';
import { CartDetailsSourceIdsEnum } from './cartDetails/data-source-ids.enum';
import { DataLayerService } from '../customer-actions/data-layer.service';
import { IBundle, IDevice, ICartDetails } from '../interfaces/cart-details.interface';
import { ExternalInterfacesService } from '../external-interfaces/external-interfaces.service';

export class AccessoryFirstPageModel extends AccessorySecondPageModel {
  public bundleNumber: number;
  public offerId: string;
  public processType: ProcessTypeEnum;
  public loader: LoaderMessage;
  public offerLegalInfoList: OfferLegalInfoList[];

  private endpoint: any = AppInjector.get('Endpoint');
  private loaderService: LoadersService = AppInjector.get(LoadersService);
  private notificationProvider: NotificationProviderService = AppInjector.get(NotificationProviderService);
  private dataLayerService: DataLayerService = AppInjector.get(DataLayerService);
  private externalInterfacesService: any = AppInjector.get(ExternalInterfacesService);

  constructor(bundle: IBundle, accessory: IDevice, commonInfo: CommonInfoService) {
    super(bundle, accessory, commonInfo);

    this.bundleNumber = bundle.number;
    this.offerId = bundle.offer.offerId;
    this.processType = bundle.processType;
    this.offerLegalInfoList = bundle.offer.offerLegalInfoList;
  }

  public incrementAccessory(): void {
    this.startLoader();

    this.endpoint('accessory.quantity')
      .requestData({
        accessorySku: this.sku,
        b2c: this.commonInfo.b2c,
        bundleNo: this.bundleNumber,
        delta: 1,
        force: true,
        offerId: this.offerId
      })
      .queue()
      .run()
      .then((response: ICartDetails) => {
        this.quantity += 1;

        this.externalInterfacesService.updateCartDetails();
        this.sendPageValidationCartResponse(response, CartDetailsSourceIdsEnum.ACCESSORY_CHANGE_QTY);
      })
      .finally(() => {
        this.stopLoader();
      });
  }

  public decrementAccessory(): void {
    this.startLoader();

    this.endpoint('accessory.quantity')
      .requestData({
        accessorySku: this.sku,
        b2c: this.commonInfo.b2c,
        bundleNo: this.bundleNumber,
        delta: -1,
        force: true,
        offerId: this.offerId
      })
      .queue()
      .run()
      .then((response: ICartDetails) => {
        this.quantity -= 1;

        this.externalInterfacesService.updateCartDetails();
        this.sendPageValidationCartResponse(response, CartDetailsSourceIdsEnum.ACCESSORY_CHANGE_QTY);
      })
      .finally(() => {
        this.stopLoader();
      });
  }

  public removeAccessory($event: MouseEvent): void {
    $event.preventDefault();

    this.startLoader();

    this.endpoint('accessory.removeEntry')
      .requestData({
        bundleNo: this.bundleNumber,
        offerId: this.offerId,
        deviceId: this.sku
      })
      .run()
      .then((response: ICartDetails) => {
        this.sendPageValidationCartResponse(response, CartDetailsSourceIdsEnum.ACCESSORY_CHANGE_QTY);
      })
      .finally(() => {
        this.stopLoader();
      });
  }

  public isDisableAddAccessory(): boolean {
    return this.quantityLimitReached;
  }

  public isDisableRemoveAccessory(): boolean {
    return this.quantity <= 1;
  }

  private sendPageValidationCartResponse(response: ICartDetails, additionalId?: CartDetailsSourceIdsEnum): void {
    if (!response) {
      return;
    }

    if (additionalId && response) {
      response._sourceId = additionalId;
      response._sourceToken = this.dataLayerService.getToken(additionalId);
    }

    this.notificationProvider.publish(
      NotificationProviderTypeEnum.PAGE_VALIDATION_CART,
      response
    );
  }

  private startLoader(): void {
    this.loaderService.start(
      LoaderActions.MODAL_LOADER,
      {
        message: 'Sprawdzamy dostępność urządzeń',
        preventClose: true
      },
      true
    );
  }

  private stopLoader(): void {
    this.loaderService.stop(
      LoaderActions.MODAL_LOADER
    );
  }
}



